import { createSelector, createFeatureSelector } from '@ngrx/store';
import * as fromWidgetColumnReducers from '@feature/widget-columns/reducers/widget-columns.reducer';
import { WidgetInstanceColumns } from '@feature/widget-columns/widget-columns-types';

export const selectWidgetColumnsState = createFeatureSelector<fromWidgetColumnReducers.State>(fromWidgetColumnReducers.widgetColumnsFeatureKey);

const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = fromWidgetColumnReducers.adapter.getSelectors(selectWidgetColumnsState);

const selectEntityByWidgetId = (widgetId: number) => createSelector(selectEntities, (entities) => entities[widgetId]);

export const isLoading = (widgetId: number) => createSelector([selectEntityByWidgetId(widgetId)],
  (widgetColumnsInstance: WidgetInstanceColumns) => {
  return widgetColumnsInstance.loading;
});

export const availableColumns = (widgetId: number) => createSelector([selectEntityByWidgetId(widgetId)],
  (widgetColumnsInstance: WidgetInstanceColumns) => {
    if (widgetColumnsInstance) {
      return widgetColumnsInstance.columns;
    } else {
      return [];
    }
  });

